import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dc, { d3, crossfilter } from 'dc';
import BaseChart from './baseChart';
import * as chartsUtilFunctions from './util/chartsUtilFunctions';
import * as utilFunctions from './util/utilFunctions';
import $ from 'jquery';

class AlertCurveChart extends BaseChart {
  constructor(props, context) {
    super(props, context);
    this.state = utilFunctions.mergeState(this.state, {
      config: utilFunctions.mergeState(this.state.config, {
        valueFormat: utilFunctions.getValueFormatDefault(),
        separatorsNumber: 7,
        daysToShow: 13,
        eventsCol: {
          type: null,
          start: null,
          length: null,
          lane: null,
          zIndex: null,
          isStart: null,
          isEnd: null,
          place: null,
          sleepTooltip: null
        },
        levelsNames: {
          '0': '',
          '1': '',
          '2': ''
        },
        eventsLabels: [],
        eventsToHide: [],
        hideSeparators: false,
        lineHeight: 5,
        showLevel2Legend: false,
        hoursCol: {
          show: false,
          eventsToSum: []
        },
        extraIndicatorCol: {
          show: false,
          type: '',
          title: '',
          valueFormat: utilFunctions.getValueFormatDefault(),
          colorRangeParser: [],
          colorRange: [],
          fontSize: '14px'
        },
        extraIndicatorCol2: {
          show: false,
          type: '',
          title: '',
          valueFormat: utilFunctions.getValueFormatDefault(),
          colorRangeParser: [],
          colorRange: [],
          fontSize: '14px'
        }
      }),
      chartData: {},
      contentContainer: null,
      mainChartContainer: null,
      labelChartCointainer: null,
      lengthCointainer: null,
      extraCointainer: null,
      extraCointainer2: null,
      svgChart: null,
      headerChart: null,
      topLegendPadding: 55,
      pages: 1,
      actualPage: 1,
      upArrow: null,
      downArrow: null
    });
    this.setData = this.setData.bind(this);
    this.handleFiltered = this.handleFiltered.bind(this);
    this.changePage = this.changePage.bind(this);
    this.state.extraClass = 'workdayChart alertCurveChart';
    this.state.tooltipObjectClass = '.toolTipMe';
  }

  getChartTypeInstance() {
    return null;
  }

  stylingAndFormat() {}
  postRenderOperations() {}
  preRenderOperations() {}
  setSize() {}

  initializeBasicChartConfig() {
    this.state.config = chartsUtilFunctions.setConfigParams(this.props.config, this.state.config);
    this.state.chart = this.getChartTypeInstance();

    this.state.labelsLookup = {};

    for (var i = 0; i < this.state.config.eventsLabels.length; i++) {
      var eventLabel = this.state.config.eventsLabels[i];

      if (eventLabel.level in this.state.labelsLookup == false) {
        this.state.labelsLookup[eventLabel.level] = {};
      }

      this.state.labelsLookup[eventLabel.level][eventLabel.type] = {
        index: i,
        label: eventLabel.label
      };
    }

    this.setMetrics();

    this.state.tooltipFormatFunction = this.getTooltipFormatFunction();
  }

  setData() {
    var leftPadding = 100;
    var leftLanesPadding = 10;
    var rightLanesPadding = 10;
    var rightHourPadding = 100;
    var rightExtraPadding = 100;
    var rightExtraPadding2 = 100;
    var headerHeight = 50;
    var topPadding = 0;
    var totalW = this.state.width;
    var totalH = this.state.height - this.state.topLegendPadding - headerHeight;
    var w;
    var h;
    var smallBarHeight = 2;
    var radious = 7;
    var lanes = [];
    var lanesUtc = [];
    var tenMilisecDay = 1000 * 60 * 60 * 24;
    var separators = this.state.config.separatorsNumber;
    var separatorFormaterFunction = utilFunctions.getFormatFunction({
      type: 'NUMBER',
      format: 'hh:mm'
    });

    if (this.state.config.hoursCol.show == false) {
      rightHourPadding = 0;
    }

    if (this.state.config.extraIndicatorCol.show == false) {
      rightExtraPadding = 0;
    }

    if (this.state.config.extraIndicatorCol2.show == false) {
      rightExtraPadding2 = 0;
    }

    w = totalW - leftPadding - rightHourPadding - rightExtraPadding-rightExtraPadding2;
    h = totalH - topPadding;

    if (this.state.svgChart != null) {
      this.state.svgChart.remove();
    }

    if (this.state.headerChart != null) {
      this.state.headerChart.remove();
    }

    this.state.headerChart = d3
      .select('#' + this.props.id)
      .append('div')
      .style('width', totalW + "px")
      .attr('class', 'chartHeader');

    this.state.svgChart = d3
      .select('#' + this.props.id)
      .append('svg')
      .attr('width', totalW)
      .attr('height', totalH)
      .attr('class', 'chart');

    this.state.svgChart
      .append('defs')
      .append('clipPath')
      .attr('id', 'clip')
      .append('rect')
      .attr('width', w)
      .attr('height', h);

    this.state.contentContainer = this.state.svgChart
      .append('g')
      .attr('transform', 'translate(0,' + topPadding + ')')
      .attr('width', totalW)
      .attr('height', h)
      .attr('class', 'main');

    this.state.labelChartCointainer = this.state.contentContainer
      .append('g')
      .attr('transform', 'translate(0,0)')
      .attr('width', leftPadding)
      .attr('height', h)
      .attr('class', 'main');

    this.state.mainChartContainer = this.state.contentContainer
      .append('g')
      .attr('transform', 'translate(' + leftPadding + ',0)')
      .attr('width', w)
      .attr('height', h)
      .attr('class', 'main');

    this.state.lengthCointainer = this.state.contentContainer
      .append('g')
      .attr('transform', 'translate(' + (leftPadding + w) + ',0)')
      .attr('width', rightHourPadding)
      .attr('height', h)
      .attr('class', 'main');

    this.state.extraCointainer = this.state.contentContainer
      .append('g')
      .attr('transform', 'translate(' + (leftPadding + w + rightHourPadding + rightExtraPadding2) + ',0)')
      .attr('width', rightExtraPadding)
      .attr('height', h)
      .attr('class', 'main');

    this.state.extraCointainer2 = this.state.contentContainer
      .append('g')
      .attr('transform', 'translate(' + (leftPadding + w + rightHourPadding) + ',0)')
      .attr('width', rightExtraPadding2)
      .attr('height', h)
      .attr('class', 'main');

    this.state.headerChart
      .append('div')
      .html(this.props.language.driver_fatigue.graphAlertStateLabels.day)
      .attr('class', 'headerText hoursHeaderTitle')
      .attr("id","alertCurveDayHeader")
      .style('width', (leftPadding-1) + "px");

    var headerHoursContainer = this.state.headerChart
      .append('div')
      .attr("id","alertCurveHoursHeader")
      .attr('class', 'headerText hoursHeaderContainer');

    headerHoursContainer
      .append('div')
      .html('00:00')
      .attr('class', 'headerText');

    for (var i = 0; i < separators; i++) {
      headerHoursContainer
        .append('div')
        .html(separatorFormaterFunction((24 / (separators + 1)) * (i + 1))
              .replace('h', '')
              .replace('m', ''))
        .attr('class', 'headerText');
    }

    headerHoursContainer
      .append('div')
      .html('23:59')
      .attr('class', 'headerText');

    if (this.state.config.hoursCol.show == true) {
      this.state.headerChart
        .append('div')
        .html(this.props.language.driver_fatigue.graphAlertStateLabels.hours)
        .attr('class', 'headerText')
        .style('width', (rightHourPadding-1) + "px");
    }

    if (this.state.config.extraIndicatorCol2.show == true) {
      this.state.headerChart
        .append('div')
        .html(this.state.config.extraIndicatorCol2.title)
        .attr('class', 'headerText hoursHeaderTitle')
        .attr("id","alertCurveExtraIndicator2Header")
        .style('width', (rightExtraPadding2+1) + "px");
    }

    if (this.state.config.extraIndicatorCol.show == true) {
      this.state.headerChart
        .append('div')
        .html(this.state.config.extraIndicatorCol.title)
        .attr('class', 'headerText hoursHeaderTitle')
        .attr("id","alertCurveExtraIndicatorHeader")
        .style('width', (rightExtraPadding-2) + "px");
    }

    this.state.svgChart
      .append('line')
      .attr('x1', leftPadding - 1)
      .attr('y1', 0)
      .attr('x2', leftPadding - 1)
      .attr('y2', totalH)
      .attr('stroke', '#f5f5f5')
      .attr('stroke-width', 1)
      .style('pointer-events', 'none');

    if (this.state.config.hoursCol.show == true) {
      this.state.svgChart
        .append('line')
        .attr('x1', leftPadding + w + 1)
        .attr('y1', 0)
        .attr('x2', leftPadding + w + 1)
        .attr('y2', totalH)
        .attr('stroke', '#f5f5f5')
        .attr('stroke-width', 1)
        .style('pointer-events', 'none');
    }

    if (this.state.config.extraIndicatorCol2.show == true) {
      this.state.svgChart
        .append('line')
        .attr('x1', leftPadding + w + rightHourPadding + 1)
        .attr('y1', 0)
        .attr('x2', leftPadding + w + rightHourPadding + 1)
        .attr('y2', totalH)
        .attr('stroke', '#f5f5f5')
        .attr('stroke-width', 1)
        .style('pointer-events', 'none');
    }

    if (this.state.config.extraIndicatorCol.show == true) {
      this.state.svgChart
        .append('line')
        .attr('x1', leftPadding + w + rightHourPadding + rightExtraPadding2 + 1)
        .attr('y1', 0)
        .attr('x2', leftPadding + w + rightHourPadding + rightExtraPadding2 + 1)
        .attr('y2', totalH)
        .attr('stroke', '#f5f5f5')
        .attr('stroke-width', 1)
        .style('pointer-events', 'none');
    }

    var top = this.state.crossfilter.getDim().top(1);

    if (top.length == 0) {
      return false;
    }

    var bottom = this.state.crossfilter.getDim().bottom(1);

    var runFormatFunctions = chartsUtilFunctions.runFormatFunctions;
    var formatFunction = utilFunctions.getFormatFunction(this.state.config.valueFormat);
    var max = runFormatFunctions(
      this.props.dimension.formatFunction,
      top[0][this.props.dimension.name]
    );
    var min = runFormatFunctions(
      this.props.dimension.formatFunction,
      bottom[0][this.props.dimension.name]
    );
    var laneHours = [];
    var laneExtra = [];
    var laneExtra2 = [];
    var laneExtra2Data = [];
    var suggestedMaxMin = { max: max, min: min };
    /*var suggestedMaxMin = chartsUtilFunctions.getRangeFromFilterBounds(
      this.props.getParamsFunction(),
      this.props.dimension.originalName,
      min,
      max
    );*/
    max = suggestedMaxMin.max;
    min = Math.max(suggestedMaxMin.min, max - tenMilisecDay * this.state.config.daysToShow);

    for (var i = max; i >= min; i = i - tenMilisecDay) {
      var auxDate = new Date(i);
      auxDate.setTime(i + auxDate.getTimezoneOffset() * 60000);
      lanes[lanes.length] = formatFunction(auxDate);
      lanesUtc[lanesUtc.length] = i;
      laneHours[laneHours.length] = 0;
      laneExtra[laneExtra.length] = null;
      laneExtra2[laneExtra2.length] = null;
      laneExtra2Data[laneExtra2Data.length] = null;
    }

    var laneHeight = Math.min(Math.max(36, h / lanes.length), 100);
    this.state.pages = Math.ceil((lanes.length * laneHeight) / h);
    var x = d3.scale
      .linear()
      .domain([0, 24])
      .range([leftLanesPadding, w - rightLanesPadding]);
    var widthX = d3.scale
      .linear()
      .domain([0, 24])
      .range([0, w - rightLanesPadding - leftLanesPadding]);
    var y1 = d3.scale
      .linear()
      .domain([0, lanes.length])
      .range([0, laneHeight * lanes.length]);

    var items = this.state.crossfilter.getDim().top(Infinity);

    var lanesSelection = this.state.mainChartContainer
      .append('g')
      .selectAll('.lanes')
      .data(lanes)
      .enter();

    const handleMouseEnterLane = function(d, i) {
      d3.selectAll(".lane-group-"+i)
      .style('fill',"#f0f0f0");
    }.bind(this);

    const handleMouseLeaveLane = function(d, i) {
      d3.selectAll(".lane-group-"+i)
      .style('fill',"#fff");
    }.bind(this);

    const handleMouseEnterExtraIndicator2 = function(d, i) {
      d3.selectAll(".hoverLongBar-group"+i)
      .classed("active", true);
    }.bind(this);

    const handleMouseLeaveExtraIndicator2 = function(d, i) {
      d3.selectAll(".hoverLongBar-group"+i)
      .classed("active", false);
    }.bind(this);

    const handleMouseEnterSegment = function(d, id) {
      /*d3.selectAll(".hoverLongBar-id"+id)
      .classed("active", true);*/
    }.bind(this);

    const handleMouseLeaveSegment = function(d, id) {
      /*d3.selectAll(".hoverLongBar-id"+id)
      .classed("active", false);*/
    }.bind(this);

    //lane area events
    lanesSelection
      .append('rect')
      .attr('x', 0)
      .attr('y', function(d, i) {
        return y1(i);
      })
      .attr('width', w)
      .attr('height', laneHeight)
      .attr('class', function(d, i) {
        return "lane-rect lane-group-"+i;
      })
      .style('fill','#FFF')
      .on('mouseenter', handleMouseEnterLane)
      .on('mouseleave',handleMouseLeaveLane);

    lanesSelection = this.state.labelChartCointainer
      .append('g')
      .selectAll('.lanes')
      .data(lanes)
      .enter();

    //lane area date
    lanesSelection
      .append('rect')
      .attr('x', 0)
      .attr('y', function(d, i) {
        return y1(i);
      })
      .attr('width', leftPadding)
      .attr('height', laneHeight)
      .attr('class', function(d, i) {
        return "lane-rect lane-group-"+i;
      })
      .style('fill','#FFF')
      .on('mouseenter', handleMouseEnterLane)
      .on('mouseleave',handleMouseLeaveLane);

    lanesSelection
      .append('text')
      .text(function(d) {
        return d;
      })
      .attr('x', leftPadding / 2)
      .attr('y', function(d, i) {
        return y1(i + 0.5);
      })
      .attr('dy', '.5ex')
      .attr('text-anchor', 'middle')
      .attr('class', 'laneText')
      .style('pointer-events', 'none');

    lanesSelection = this.state.lengthCointainer
      .append('g')
      .selectAll('.lanes')
      .data(lanes)
      .enter();

    //lane area hours
    lanesSelection
      .append('rect')
      .attr('x', 0)
      .attr('y', function(d, i) {
        return y1(i);
      })
      .attr('width', rightHourPadding)
      .attr('height', laneHeight)
      .attr('class', function(d, i) {
        return "lane-rect lane-group-"+i;
      })
      .style('fill','#FFF')
      .on('mouseenter', handleMouseEnterLane)
      .on('mouseleave',handleMouseLeaveLane);

    lanesSelection = this.state.extraCointainer
      .append('g')
      .selectAll('.lanes')
      .data(lanes)
      .enter();

    //lane area extra indicator
    lanesSelection
      .append('rect')
      .attr('x', 0)
      .attr('y', function(d, i) {
        return y1(i);
      })
      .attr('width', rightExtraPadding)
      .attr('height', laneHeight)
      .attr('class', function(d, i) {
        return "lane-rect lane-group-"+i;
      })
      .style('fill','#FFF')
      .on('mouseenter', handleMouseEnterLane)
      .on('mouseleave',handleMouseLeaveLane);

    lanesSelection = this.state.extraCointainer2
      .append('g')
      .selectAll('.lanes')
      .data(lanes)
      .enter();

    //lane area extra indicator2
    lanesSelection
      .append('rect')
      .attr('x', 0)
      .attr('y', function(d, i) {
        return y1(i);
      })
      .attr('width', rightExtraPadding2)
      .attr('height', laneHeight)
      .attr('class', function(d, i) {
        return "lane-rect lane-group-"+i;
      })
      .style('fill','#FFF')
      .on('mouseenter', handleMouseEnterLane)
      .on('mouseleave',handleMouseLeaveLane);


    for (var i = 0; i < separators; i++) {
      this.state.mainChartContainer
        .append('line')
        .attr(
          'x1',
          leftLanesPadding +
            ((i + 1) * (w - rightLanesPadding - leftLanesPadding)) / (separators + 1)
        )
        .attr('y1', 0)
        .attr(
          'x2',
          leftLanesPadding +
            ((i + 1) * (w - rightLanesPadding - leftLanesPadding)) / (separators + 1)
        )
        .attr('y2', h)
        .attr('stroke', '#f5f5f5')
        .attr('stroke-width', 1)
        .style('pointer-events', 'none');
    }

    var itemsSelection = {};

    for (var key in this.state.labelsLookup) {
      itemsSelection[key] = this.state.mainChartContainer.append('g');
    }

    itemsSelection['circle'] = this.state.mainChartContainer.append('g');

    for (var i = 0; i < items.length; i++) {
      var d = items[i];
      var lane = lanesUtc.indexOf(d[this.state.config.eventsCol.lane]);
      var startDate = d[this.state.config.eventsCol.lane];
      var length = d[this.state.config.eventsCol.length];
      var start = d[this.state.config.eventsCol.start];
      var zIndex = d[this.state.config.eventsCol.zIndex];
      var _type = d[this.state.config.eventsCol.type];
      var place = d[this.state.config.eventsCol.place];
      var sleepTooltip = d[this.state.config.eventsCol.sleepTooltip];
      var color = this.state.config.colors[0];

      if (zIndex in this.state.labelsLookup && _type in this.state.labelsLookup[zIndex]) {
        color = this.state.config.colors[this.state.labelsLookup[zIndex][_type].index];
      }

      if (
        d[this.state.config.eventsCol.lane] >= lanesUtc[lanesUtc.length - 1] - tenMilisecDay &&
        zIndex in itemsSelection &&
        _type != this.state.config.extraIndicatorCol.type &&
        _type != this.state.config.extraIndicatorCol2.type
      ) {
        //para que tome en cuenta el dia anterior al corte y no deje turnos mal cortados
        if (lanesUtc[lanesUtc.length - 1] - tenMilisecDay == d[this.state.config.eventsCol.lane]) {
          lane = lanesUtc.length;
        }

        var days = Math.floor((start + length) / 24) + 1;
        var hoursLastDay = (start + length) % 24;

        if (hoursLastDay == 0) {
          days -= 1;
        }

        var label = '';
        if (zIndex in this.state.labelsLookup && _type in this.state.labelsLookup[zIndex]) {
          label = this.state.labelsLookup[zIndex][_type].label;
        }
        //hack rapido para esconder el lugar si es null (ver tooltip en basechart)
        if (place == null) {
          place = 'HIDE';
        }

        var eventData = {
          length: length,
          type: label,
          startDate: startDate + start * 3600 * 1000,
          endDate: startDate + (start + length) * 3600 * 1000,
          place: place
        };

        if(length == null) {
          eventData.endDate = null;
        }

        var eventObjects = [];

        for (var j = 1; j <= days; j++) {
          var iterStart;
          var iterLength;
          var iterLane = lane - (j - 1);
          var iterBarHeight = this.state.config.lineHeight;
          var iterOffset = 0;

          if (iterLane >= 0 && iterLane < lanesUtc.length) {
            if (j == 1) iterStart = start;
            else iterStart = 0;

            if (j == 1 && days == 1) iterLength = length;
            else if (j < days && j == 1) iterLength = 24 - start;
            else if (j < days) iterLength = 24;
            else iterLength = hoursLastDay;

            if (zIndex == 2) {
              iterBarHeight = smallBarHeight;
              iterOffset = -radious - 5;
            }

            if (this.state.config.hoursCol.eventsToSum.indexOf(_type) >= 0) {
              laneHours[iterLane] += iterLength;
            }

            //lineaInicioEvento
            if (this.state.config.hideSeparators==false &&
              j == 1 && zIndex != 2) {
              itemsSelection[zIndex]
                .append('rect')
                .attr('x', x(iterStart))
                .attr('y', y1(iterLane + 0.5) - (iterBarHeight * 2.5) / 2)
                .attr('width', 3)
                .attr('height', iterBarHeight * 2.5)
                .style('fill', color);
            }

            if(this.state.config.eventsToHide.indexOf(_type) < 0) {
              //evento
              itemsSelection[zIndex]
                .append('rect')
                .attr('x', x(iterStart))
                .attr('y', y1(iterLane + 0.5) - iterBarHeight / 2 + iterOffset)
                .attr('width', widthX(iterLength))
                .attr('height', iterBarHeight)
                .attr('class', 'longBar')
                .style('fill', color);

              eventObjects[eventObjects.length] = itemsSelection[zIndex]
                .append('rect')
                .attr('x', x(iterStart))
                .attr('y', y1(iterLane + 0.5) - (iterBarHeight) / 2 + iterOffset)
                .attr('width', widthX(iterLength))
                .attr('height', iterBarHeight)
                .style('fill', 'transparent')
                .attr('class', 'toolTipMe')
                .on('mouseenter', (function(_laneId,d,i) {
                  handleMouseEnterLane(d,_laneId);
                }).bind(this,iterLane))
                .on('mouseout', (function(_laneId,d,i) {
                  handleMouseLeaveLane(d,_laneId);
                }).bind(this,iterLane));
            }
            else {
              //evento mostrable en hover
              var laneUtcEvent = eventData.endDate - eventData.endDate%(24*60*60*1000);
              var eventLaneGroup = lanesUtc.indexOf(laneUtcEvent);
              var eventId = eventData.startDate;
              itemsSelection[zIndex]
                .append('rect')
                .attr('x', x(iterStart))
                .attr('y', y1(iterLane + 0.5) - iterBarHeight / 2 + iterOffset)
                .attr('width', widthX(iterLength))
                .attr('height', iterBarHeight)
                .attr('class', 'longBar hoverLongBar hoverLongBar-group'
                  + eventLaneGroup  + " hoverLongBar-id" + eventId)
                .style('fill', color);

              eventObjects[eventObjects.length] = itemsSelection[zIndex]
                .append('rect')
                .attr('x', x(iterStart))
                .attr('y', y1(iterLane + 0.5) - (iterBarHeight) / 2 + iterOffset)
                .attr('width', widthX(iterLength))
                .attr('height', iterBarHeight)
                .style('fill', 'transparent')
                .attr('class', 'toolTipMe hoverLongBar hoverLongBar-group'
                  + eventLaneGroup + " hoverLongBar-id" + eventId)
                .on('mouseenter', (function(_laneId,_eventId,d,i) {
                  handleMouseEnterSegment(d,_eventId);
                  handleMouseEnterLane(d,_laneId);
                }).bind(this,iterLane,eventId))
                .on('mouseout', (function(_laneId,_eventId,d,i) {
                  handleMouseLeaveSegment(d,_eventId);
                  handleMouseLeaveLane(d,_laneId);
                }).bind(this,iterLane,eventId));
            }

            //comienzo gran evento
            if (d[this.state.config.eventsCol.isStart] == true && j == 1) {
              eventObjects[eventObjects.length] = itemsSelection['circle']
                .append('circle')
                .attr('cx', x(iterStart))
                .attr('cy', y1(iterLane + 0.5))
                .attr('r', radious)
                .style('fill', "#CC5660")
                .attr('stroke', '#ffdbde')
                .attr('stroke-width', '2')
                .attr('class', 'toolTipMe')
                .on('mouseenter', (function(_laneId,d,i) {
                  handleMouseEnterLane(d,_laneId);
                }).bind(this,iterLane))
                .on('mouseout', (function(_laneId,d,i) {
                  handleMouseLeaveLane(d,_laneId);
                }).bind(this,iterLane));
            }

            //fin gran evento
            if (d[this.state.config.eventsCol.isEnd] == true && j == days) {
              eventObjects[eventObjects.length] = itemsSelection['circle']
                .append('circle')
                .attr('cx', x(iterStart + iterLength))
                .attr('cy', y1(iterLane + 0.5))
                .attr('r', radious)
                .style('fill', color)
                .attr('class', 'toolTipMe');
            }
          }
        }
        if(zIndex==2) {
          eventData.hour = eventData.startDate;
          eventData.event = eventData.type;

          eventData.startDate = null;
          eventData.type = null;
        }
        for (var j = 0; j < eventObjects.length; j++) {
          eventObjects[j].data([eventData]);
        }
      } else if (
        _type == this.state.config.extraIndicatorCol.type &&
        lane >= 0 &&
        lane < lanesUtc.length
      ) {
        laneExtra[lane] = length;
      } else if (
        _type == this.state.config.extraIndicatorCol2.type &&
        lane >= 0 &&
        lane < lanesUtc.length
      ) {
        laneExtra2[lane] = length;
        laneExtra2Data[lane] = [{sleepTooltip: (sleepTooltip ? sleepTooltip.tooltipMessage : "")}];
      }
    }

    if (this.state.config.hoursCol.show) {
      lanesSelection = this.state.lengthCointainer.append('g');
      var formatFunction = utilFunctions.getFormatFunction({ type: 'NUMBER', format: 'hh:mm' });

      for (var i = 0; i < laneHours.length; i++) {
        lanesSelection
          .append('text')
          .text(formatFunction(laneHours[i]))
          .attr('x', rightHourPadding / 2)
          .attr('y', y1(i + 0.5))
          .attr('dy', '.5ex')
          .attr('text-anchor', 'middle')
          .attr('class', 'laneHours');
      }
    }

    if (this.state.config.extraIndicatorCol.show) {
      lanesSelection = this.state.extraCointainer.append('g');
      var formatFunction = utilFunctions.getFormatFunction(
        this.state.config.extraIndicatorCol.valueFormat
      );

      for (var i = 0; i < laneExtra.length; i++) {
        var colorProps = chartsUtilFunctions.getColorProps(
          this.state.config.extraIndicatorCol.colorRange,
          laneExtra[i],
          this.state.config.extraIndicatorCol.colorRangeParser
        );
        var value = formatFunction(laneExtra[i]);
        var laneId = i;
        lanesSelection
          .append('text')
          .text(value)
          .attr('x', rightExtraPadding / 2)
          .attr('y', y1(i + 0.5))
          .attr('dy', '.5ex')
          .attr('text-anchor', 'middle')
          .attr('class', 'laneHours')
          .style('fill', colorProps.color)
          .style('font-size', this.state.config.extraIndicatorCol.fontSize)
          .style('font-weight', 'bold')
          .style('pointer-events', 'none');
      }
    }

    if (this.state.config.hoursCol.show) {
      lanesSelection = this.state.lengthCointainer.append('g');
      var formatFunction = utilFunctions.getFormatFunction({ type: 'NUMBER', format: 'hh:mm' });

      for (var i = 0; i < laneHours.length; i++) {
        var laneId = i;
        lanesSelection
          .append('text')
          .text(formatFunction(laneHours[i]))
          .attr('x', rightHourPadding / 2)
          .attr('y', y1(i + 0.5))
          .attr('dy', '.5ex')
          .attr('text-anchor', 'middle')
          .attr('class', 'laneHours')
          .style('pointer-events', 'none');
      }
    }

    if (this.state.config.extraIndicatorCol2.show) {
      lanesSelection = this.state.extraCointainer2.append('g');
      var formatFunction = utilFunctions.getFormatFunction(
        this.state.config.extraIndicatorCol2.valueFormat
      );

      for (var i = 0; i < laneExtra2.length; i++) {
        var colorProps = chartsUtilFunctions.getColorProps(
          this.state.config.extraIndicatorCol2.colorRange,
          laneExtra2[i],
          this.state.config.extraIndicatorCol2.colorRangeParser
        );
        var value = formatFunction(laneExtra2[i]);
        var icon = "\u2713";
        var laneId = i;
        if(value >= 2 ) {
          icon = "\u2717";
        }

        lanesSelection
          .append('rect')
          .attr('x', 0)
          .attr('y', y1(i))
          .attr('width', rightExtraPadding2)
          .attr('height', laneHeight)
          .attr('class', 'toolTipMe')
          .style('fill','transparent')
          .data(laneExtra2Data[i])
          .on('mouseenter', (function(_laneId,d,i) {
            handleMouseEnterLane(d,_laneId);
            handleMouseEnterExtraIndicator2(d,_laneId);
          }).bind(this,laneId))
          .on('mouseout',(function(_laneId,d,i) {
            handleMouseLeaveLane(d,_laneId);
            handleMouseLeaveExtraIndicator2(d,_laneId);
          }).bind(this,laneId));

        lanesSelection
          .append('text')
          .text(icon)
          .attr('x', rightExtraPadding2 / 2)
          .attr('y', y1(i+0.5))
          .attr('dy', '.5ex')
          .attr('text-anchor', 'middle')
          .style('fill', colorProps.color)
          .style('font-size', this.state.config.extraIndicatorCol2.fontSize)
          .style('font-weight', 'bold')
          .style('pointer-events', 'none');
      }
    }

    this.state.upArrow = this.state.svgChart
      .append('path')
      .attr('transform', 'translate(' + (leftPadding + 15) + ',' + (h / 2 - 13 + topPadding) + ')')
      .attr(
        'd',
        d3.svg
          .symbol()
          .type('triangle-up')
          .size(130)
      )
      .attr('class', 'arrowChart')
      .style('visibility', 'hidden')
      .on(
        'click',
        function(d, i) {
          this.changePage(h, topPadding, -1);
        }.bind(this)
      );

    this.state.downArrow = this.state.svgChart
      .append('path')
      .attr('transform', 'translate(' + (leftPadding + 15) + ',' + (h / 2 + 13 + topPadding) + ')')
      .attr(
        'd',
        d3.svg
          .symbol()
          .type('triangle-down')
          .size(130)
      )
      .attr('class', 'arrowChart')
      .style(
        'visibility',
        function() {
          if (this.state.pages > 1) {
            return 'visible';
          }
          return 'hidden';
        }.bind(this)
      )
      .on(
        'click',
        function(d, i) {
          this.changePage(h, topPadding, 1);
        }.bind(this)
      );

    this.applyToolTips(this.state.svgChart,false);
  }

  changePage(height, topPadding, pages) {
    this.state.actualPage += pages;
    if (this.state.actualPage == this.state.pages) {
      this.state.downArrow.style('visibility', 'hidden');
    } else {
      this.state.downArrow.style('visibility', 'visible');
    }
    if (this.state.actualPage == 1) {
      this.state.upArrow.style('visibility', 'hidden');
    } else {
      this.state.upArrow.style('visibility', 'visible');
    }
    this.state.contentContainer.attr(
      'transform',
      'translate(0,' + (topPadding - height * (this.state.actualPage - 1)) + ')'
    );
  }

  setMetrics() {
    this.state.chart = true;
    this.setData();
  }

  handleResize() {
    d3.select(this.refs.containerDivDom).classed('showComponent', true);
    this.setState({
      width: this.refs.containerDivDom.clientWidth,
      height: this.refs.containerDivDom.clientHeight
    });
    this.setData();
  }

  renderOrRedraw() {
    if (this.state.chart == null) {
      this.makeChart();
      this.setState({ chart: true });
      d3.select(this.refs.containerDivDom).classed('showComponent', true);
    } else {
    }
  }

  handleFiltered() {
    utilFunctions.asyncFunction(this.setData);
  }

  componentDidMount() {
    super.componentDidMount();
    $('body').on('filtered' + this.props.dashboardId, this.handleFiltered);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    $('body').off('filtered' + this.props.dashboardId, this.handleFiltered);

    if (this.state.upArrow) {
      this.state.upArrow.on('click', null);
    }
    if (this.state.downArrow) {
      this.state.downArrow.on('click', null);
    }
  }

  render() {
    var chart = null;
    var legend = [];
    var tooltipText = d3.select('#pageTooltip .tooltip-inner');
    var tooltip = d3.select('#pageTooltip');

    if (this.state.chart == true) {
      chart = null;
      for (var key in this.state.labelsLookup) {
        if (key == 1) {
          var legendChilds = [];
          for (var secondKey in this.state.labelsLookup[key]) {
            var color = this.state.config.colors[this.state.labelsLookup[key][secondKey].index];
            legendChilds[legendChilds.length] = (
              <div key={legendChilds.length} className="subLegendWrapper">
                <div
                  className="legendItem"
                  style={{ backgroundColor: color }}
                />
              </div>
            );
          }
          legend[legend.length] = (
            <div key={legend.length} className="legendWrapper">
              <div className="scaleLegendWrapper" id="scaleLegendWrapper">
                <div className="legendLabel">{this.props.language.driver_fatigue.graphAlertStateLabels.a1}</div>
                {legendChilds}
                <div className="legendLabel final">{this.props.language.driver_fatigue.graphAlertStateLabels.a7}</div>
              </div>
              <div className="sleepLegendWrapper subLegendWrapper vertical" id="sleepLegendWrapper">
                <div className="legendItemWrapper">
                  <div
                    className="legendItem"
                    style={{ backgroundColor: this.state.config.colors[0] }}
                  />
                  <div className="legendLabel final">{this.props.language.driver_fatigue.graphAlertStateLabels.sleepPeriods}</div>
                </div>
                <div className="legendItemWrapper">
                  <div
                    className="legendItem"
                    style={{ backgroundColor: "#CEDFE6" }}
                  />
                  <div className="legendLabel final">{this.props.language.driver_fatigue.graphAlertStateLabels.featuredSleepPeriods}</div>
                </div>
              </div>
              {this.state.config.showLevel2Legend && (
                <div className="roadWarningLegendWrapper subLegendWrapper vertical"  id="roadWarningLegendWrapper">
                  <div className="legendItemWrapper">
                    <div
                      className="legendItem"
                      style={{ backgroundColor: "#CC5660" }}
                    />
                    <div className="legendLabel final">{this.props.language.driver_fatigue.graphAlertStateLabels.roadWarning}</div>
                  </div>
                </div>
              )}
            </div>
          );
        }
      }
    }

    return (
      <div
        className={'animateOnLoad autoResizeComponent ' + this.state.extraClass}
        ref="containerDivDom"
        id={this.props.id}
      >
        <div className="workdayLegend">{legend}</div>
        {chart}
      </div>
    );
  }
}

export default AlertCurveChart;



// WEBPACK FOOTER //
// ./source/client/components/common/graphs/crossfilterGraphs/alertCurveChart.jsx